<div class="port-assignments-tab">
  <!-- Header Section -->
  <div class="d-flex justify-content-between align-items-start mb-4">
    <div>
      <h5 class="mb-1"><i class="bi bi-gear me-2"></i>Agent Port Assignments</h5>
      <p class="text-muted small mb-0">Agent Port Assignments</p>
      <p class="text-muted small mb-0">Manage which ports are assigned to each agent</p>
    </div>
    <button class="btn btn-primary">
      <i class="bi bi-plus-circle me-2"></i>Assign Port
    </button>
  </div>

  <!-- Agent Cards Grid -->
  <div class="row g-3">
    <div class="col-md-4" *ngFor="let agent of agents">
      <div class="card h-100">
        <div class="card-body">
          <!-- Agent Header -->
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="d-flex align-items-center">
              <i class="bi bi-building text-primary me-2" style="font-size: 1.25rem;"></i>
              <h6 class="mb-0 fw-semibold">{{ agent.agentName }}</h6>
            </div>
            <span class="badge bg-secondary">{{ agent.assignedPorts }}</span>
          </div>

          <!-- Assigned Ports Label -->
          <p class="text-muted small mb-2">Assigned Ports</p>

          <!-- Empty State or Port List -->
          <div *ngIf="agent.assignedPorts === 0" class="text-center py-4">
            <i class="bi bi-inbox text-muted" style="font-size: 2rem;"></i>
            <p class="text-muted small mt-2 mb-3">No ports assigned</p>
            <button class="btn btn-sm btn-outline-primary" (click)="assignFirstPort(agent)">
              <i class="bi bi-plus-circle me-1"></i>Assign First Port
            </button>
          </div>

          <div *ngIf="agent.assignedPorts > 0" class="port-list">
            <div class="d-flex flex-wrap gap-2 mb-3">
              <span class="badge bg-light text-dark" *ngFor="let port of agent.ports">
                {{ port }}
              </span>
            </div>
            <button class="btn btn-sm btn-outline-primary w-100" (click)="openAssignPortModal(agent)">
              <i class="bi bi-pencil me-1"></i>Manage Ports
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Assign Port Modal (Placeholder) -->
<div class="modal fade" [class.show]="showAssignPortModal" [style.display]="showAssignPortModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Assign Port to {{ selectedAgent?.agentName }}
        </h5>
        <button type="button" class="btn-close" (click)="closeAssignPortModal()"></button>
      </div>
      <div class="modal-body">
        <p class="text-muted">Port assignment interface will be implemented here.</p>
        <p class="text-muted small">This will allow selecting multiple ports and assigning them to the agent.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAssignPortModal()">Cancel</button>
        <button type="button" class="btn btn-primary">Assign Ports</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showAssignPortModal" *ngIf="showAssignPortModal"></div>
